import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import { UCFirst } from 'display/common/utils/string';

import _ from 'lodash';
import { capitalize } from '../../../../../common/utils/string.js';

/**
 *  This is the component rendered on the bottom of the social carousel
 *  that allows paging through the slides via click on respective thumbnail
 *  or dot.
 *  @author Clay Kirk
 *
 **/
class CarouselThumbnailToolbar extends React.Component {
  constructor(props) {
    super(props);
  }

  handlePagingClick(idx, e) {
    const { showSlide } = this.props;
    showSlide(e, idx);
  }

  render() {
    const { slideCount, currentSlide, thumbnails } = this.props;
    const showThumbnails = !!thumbnails;
    return (
      <div className="xActionContainer xActionsPagination xCarouselThumbnailToolbar">
        <div className="xPaginationContainer xPaginateCollection xPaginateThumb">
          <For each="item" index="idx" of={_.range(slideCount)}>
            <a
              key={idx}
              href="#"
              className={clsx({
                activeSlide:                                      currentSlide === idx,
                xPagingIcon:                                      !showThumbnails,
                xPagingThumb:                                     showThumbnails,
                xPagingThumbText:                                 showThumbnails && isNetwork(thumbnails[idx].src),
                ['xStatus' + capitalize(thumbnails[idx].status)]: !!thumbnails[idx].status,
              })}
              onClick={this.handlePagingClick.bind(this, idx)}
            >
              <Choose>
                <When condition={showThumbnails}>
                  <If condition={isNetwork(thumbnails[idx].src)}>
                    <i className={`xIcon xIcon${UCFirst(thumbnails[idx].src)}`} />
                  </If>
                  <If condition={!isNetwork(thumbnails[idx].src)}>
                    <img src={thumbnails[idx].src} alt={thumbnails[idx].src} />
                  </If>
                </When>
                <Otherwise>
                  <i className="xIcon xIconPager" />
                </Otherwise>
              </Choose>
            </a>
          </For>
        </div>
      </div>
    );
  }
}

CarouselThumbnailToolbar.propTypes = {
  slideCount:   PropTypes.number.isRequired,
  currentSlide: PropTypes.number,
  showSlide:    PropTypes.func,
  thumbnails:   PropTypes.array,
};

CarouselThumbnailToolbar.defaultProps = {
  currentSlide: 0,
  showSlide:    _.noop,
};

const isNetwork = (thumbnail) => {
  return !(/^https?:/.test(thumbnail) || /^\/\//.test(thumbnail));
};
export default CarouselThumbnailToolbar;
